import Vue from 'vue'
import Vuex from 'vuex'
// @ts-ignore
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

import { timeline } from './timeline'
import { auth } from './auth'
import { api } from './api'

export const store = new Vuex.Store({
    modules: {
        auth,
        timeline,
        api,
    },
    plugins: [
        createPersistedState({
            paths: [
                'auth.username',
                'auth.session.jwt',
                'timeline.filter',
            ],
        }),
    ],
})



// WEBPACK FOOTER //
// ./src/store/index.ts